import type { RankedSpace, SpaceAdjustment } from "../types";
import {
  calculateCreditPricing,
  DEFAULT_SPACE_TAKE_PCT,
} from "../../pricing/marginCalculator";

export const DEFAULT_SETUP_PCT = 0.08;

export function calculateSpaceValues(
  monthlyPrice: number,
  take: number = DEFAULT_SPACE_TAKE_PCT,
  extraValue = 0,
): Omit<SpaceAdjustment, "spaceId"> {
  return calculateCreditPricing(monthlyPrice, take, extraValue);
}

export function getMonthlyPrice(space: RankedSpace): number {
  return space.monthlyPrice ?? space.pricePerWorkstation * space.capacity;
}

export function buildSpaceAdjustment(
  space: RankedSpace,
  saved?: SpaceAdjustment,
): SpaceAdjustment {
  const monthlyPrice = getMonthlyPrice(space);
  // Pass only extraValue — not margin — to avoid float back-calculation errors.
  // When margin was derived from integer credits, re-deriving extraValue from it
  // produces off-by-one values (e.g. -1) due to rounding.
  const values = calculateSpaceValues(
    monthlyPrice,
    DEFAULT_SPACE_TAKE_PCT,
    saved?.extraValue ?? 0,
  );
  const setupPct =
    saved?.setupCost != null && saved.clientPrice > 0
      ? saved.setupCost / saved.clientPrice
      : DEFAULT_SETUP_PCT;
  return {
    ...(saved ?? {}),
    spaceId: space.id,
    ...values,
    setupCost: parseFloat((values.clientPrice * setupPct).toFixed(2)),
  };
}
